import { render } from "./ProviderShow.vue?vue&type=template&id=92d7c2c8&scoped=true"
import script from "./ProviderShow.vue?vue&type=script&lang=js"
export * from "./ProviderShow.vue?vue&type=script&lang=js"

import "./ProviderShow.vue?vue&type=style&index=0&id=92d7c2c8&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92d7c2c8"]])

export default __exports__